<template>
	<div class="pxrwwfgv-screen-home">
		<div class="screen-title">Válassz területet!</div>
		<div class="pxrwwfgv-board-selector">
			<div 
				class="pxrwwfgv-board-option -sikvidek" 
				:class="{'-selected': selected === 'sikvidek'}"
				@click="selectBoard('sikvidek')"
			>
				<div>Síkvidék</div>
			</div>
			<div 
				class="pxrwwfgv-board-option -dombvidek" 
				:class="{'-selected': selected === 'dombvidek'}"
				@click="selectBoard('dombvidek')"
			>
				<div>Dombvidék</div>
			</div>
		</div>
		<div 
			class="start-button button"
			:class="{'-disabled': selected === null}"
			@click="start()"
		>Start</div>

		<HelpClickAnim left="1270" top="500" v-if="idle && !selected" />
		<HelpClickAnim left="839" top="650" v-else-if="idle && selected" />
	</div>
</template>

<script setup >
	import {ref} from 'vue';
	import {useStore} from 'vuex';
	import { useIdle } from '@vueuse/core';

	import HelpClickAnim from '@/components/ui/HelpClickAnim.vue';

	const store = useStore();

	const selected = ref(null);

	function selectBoard(board){
		selected.value = board;

		if(board === 'sikvidek'){
			store.dispatch('setEndVideos', [
				require('@/assets/videos/sv_failure.webm'),
				require('@/assets/videos/sv_normal.webm'),
				require('@/assets/videos/sv_success.webm'),
			]);
		}
		else if(board === 'dombvidek'){
			store.dispatch('setEndVideos', [
				require('@/assets/videos/dv_failure.webm'),
				require('@/assets/videos/dv_normal.webm'),
				require('@/assets/videos/dv_success.webm'),
			]);
		}
	}

	function start(){
		store.dispatch('setSelectedVidek', selected.value);
		store.dispatch('setScreen', 'description');
	}

	//help
	const { idle } = useIdle(1 * 60 * 1000); //1 min 1 * 60 * 1000
</script>

<style scoped>
	.pxrwwfgv-screen-home {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		gap: 50px;
	}
	.screen-title {
		font-family: var(--font-heading);
		letter-spacing: 1px;
		font-size: 40px;
		text-transform: uppercase;
		color: var(--color-dark-blue);
	}
	.pxrwwfgv-board-selector {
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 50px;
	}
	.pxrwwfgv-board-option {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		
		width: 680px;
		aspect-ratio: 16 / 9;
		border: 5px solid var(--color-green);
		cursor: pointer;

		transition: border-color 300ms ease-out;
	}
	.pxrwwfgv-board-option::before {
		content: '';
		display: block;
		position: absolute;
		z-index: 2;
		pointer-events: none;
		width: calc(100% + 10px);
		height: calc(100% + 10px);

		border: 0px solid #fff;
		opacity: 0;
		transform: scale(1.5);
		transition: all 300ms ease-out;
	}
	.pxrwwfgv-board-option.-selected::before {
		border-width: 10px;
		opacity: 1;
		transform: scale(1);
	}
	.pxrwwfgv-board-option.-sikvidek {
		background-image: url('@/assets/images/background_sikvidek.svg');
		background-size: cover;
		background-position: 50% 50%;
	}
	.pxrwwfgv-board-option.-dombvidek {
		background-image: url('@/assets/images/background_dombvidek.svg');
		background-size: cover;
		background-position: 50% 50%;
	}
	.pxrwwfgv-board-option div {
		position: absolute;
		top: calc(100% + 10px);
		font-family: var(--font-heading);
		letter-spacing: 1px;
		font-size: 30px;
		line-height: 1.3;
		text-transform: uppercase;
		color: var(--color-dark-blue);
	}
</style>